import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Link} from 'react-router-dom';

function Item(data){
  const {title, icon} = data;
  return(
    <div className="services-item">
      <div className="image text-center">
        <span className='services-icon' data-icon={icon}></span>
      </div>
      <div className="text">
        <h4 className="title">{title}</h4>
      </div>                   
    </div>

  )
}
const ServiceCols = (props)=>{
  const skills = {
    web:{
      title: "Web Development", icon: "web",
    },
    animation:{
      title: "3D Modeling & Animation", icon: "modeling"
    },
    game:{
      title: "2/3D Games", icon: "gamepad-min"
    },
    xr:{
      title: "XR Apps", icon: "xr"
    },
    controller:{
      title: "Physical Computing", icon: "circuit"
    },
    mobile:{
      title: "Mobile Apps", icon: "mobile"
    },
  }
  switch(props.showAll){
    case false : {
      return (<>
        <Col md={3} sm={6} >{Item(skills.web)}</Col>
        <Col md={3} sm={6} >{Item(skills.xr)}</Col>
        <Col md={3} sm={6} >{Item(skills.game)}</Col>
        <Col md={3} sm={6} >{Item(skills.mobile)}</Col>
      </>)
    }
    case true : {
      return (<>
        <Col md={3} sm={6} >{Item(skills.web)}</Col>
        <Col md={3} sm={6} >{Item(skills.xr)}</Col>
        <Col md={3} sm={6} >{Item(skills.game)}</Col>
        <Col md={3} sm={6} >{Item(skills.animation)}</Col>
        <Col md={3} sm={6} >{Item(skills.mobile)}</Col>
        <Col md={3} sm={6} >{Item(skills.controller)}</Col>
      </>)
    }
  }
}
function Services(props) {
  switch(props.showAll){
    case true: {
      return (
        <Card className='services-card content-card'>
          <Card.Body>
            <div className='card-info'>
              <Card.Title as="h1">Services I 
                <span>&nbsp;Provide</span>
              </Card.Title>
              <p className='card-subtext'>
                Crafting virtual worlds, dynamic apps, and everything in between.
              </p>
            </div>
            <div className='services-container'>
              <Row className='g-4'>
                <ServiceCols showAll={props.showAll}/>
              </Row>
            </div>
          </Card.Body>
        </Card>
      );
    }
    case false: {
      return (
        <Card className='services-card'>
          <Card.Body>
            <Card.Title as="h3">Services I Provide
                <Link to='/services' className="link-btn">
                  All Services <span data-icon="arrow"></span>
                </Link>  
            </Card.Title>
            <div className='services-container'>
              <Row className='g-4'>
                <ServiceCols showAll={props.showAll}/>
              </Row>
            </div>
          </Card.Body>
        </Card>
      );
    }
  }
}

 export default Services;